import { render, staticRenderFns } from "./Presentation2.vue?vue&type=template&id=24f634b3"
import script from "./Presentation2.vue?vue&type=script&lang=js"
export * from "./Presentation2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports